import { createContext } from "react"

// value shape: { push(id, config), pop(id) }
export const CursorContext = createContext(null)